import React, { useEffect, useState } from "react";
import eclinimg from "../../../assets/images/eclinpro.png";
import eclinfailedimg from "../../../assets/images/eClinProFailed.svg";

const EclinProSyncBadge = ({
  isSynced = true,
  IsNav = false,
  label = "eClinPro Synced",
  isSyncedStatus,
  eclinProSyncResult,
}) => {
   const [show, setShow] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
  //if (!isSynced) return null;
  
  if (!eclinProSyncResult) return null;
  const parsedErrorResult = eclinProSyncResult;
  

  console.log('parsedErrorResult => ', parsedErrorResult)

 

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({
      top: rect.bottom + 6,
      left: rect.left + rect.width / 2,
    });
    setShow(true);
  };
 
  return (
    <div className={`relative inline-flex group ${IsNav ? "ml-0" : "ml-4"}`}>
      {/* Icon */}
      {/* <img
        src={parsedErrorResult?.success === false ? eclinfailedimg : eclinimg}
        alt="eClinPro"
        className="h-6 w-6 cursor-pointer"
      /> */}

      {(isSynced === true || isSyncedStatus === 'failed') && (
        <img
          src={isSyncedStatus === 'failed' ? eclinfailedimg : eclinimg}
          alt="eClinPro"
          className="h-4 w-4 object-contain cursor-pointer inline-block ml-2"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={() => setShow(false)}
        />
      )}

      {/* Tooltip */}
      {show && (
        <div
          className="
            fixed z-[9999]
            bg-white text-[#1A1A1B]
            border border-[#E4E4E4]
            text-xs px-2 py-1 rounded
            shadow-md whitespace-nowrap
            pointer-events-none
          "
          style={{
            top: position.top,
            left: position.left,
            transform: "translateX(-50%)",
          }}
        >
          {isSyncedStatus == "failed" ? parsedErrorResult.error : label}
        </div>
      )}
    </div>
  );
};

export default EclinProSyncBadge;
